var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiploma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "align-landscape 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "car 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29 5H11C9.34315 5 8 6.67893 8 8.75V31.25C8 33.3211 9.34315 35 11 35H29C30.6569 35 32 33.3211 32 31.25V8.75C32 6.67893 30.6569 5 29 5Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5 15L12.5 18.2936L20.5 21.2222L28.5 18.2936L20.5 15Z",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5 18.2687V22.7381",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0556 19.595V23.2868C16.0546 23.4653 16.1075 23.64 16.2073 23.7879C16.3071 23.9359 16.4491 24.0504 16.615 24.1164L20.1705 25.5387C20.3823 25.624 20.6189 25.624 20.8307 25.5387L24.3863 24.1164C24.552 24.0504 24.6939 23.9359 24.7935 23.7878C24.8931 23.6398 24.9457 23.4652 24.9445 23.2868V19.595",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiploma);
export default __webpack_public_path__ + "static/media/diploma.5243c6ac7e3034c02e13f0fd550687d0.svg";
export { ForwardRef as ReactComponent };